'use client';

import { useId, useState } from 'react';

const LINKS = [
  { label: 'Privacy Policy', href: 'https://www.varsitytutors.com/privacy' },
  { label: 'Terms of Use', href: 'https://www.varsitytutors.com/terms-of-use' },
  { label: 'Accessibility', href: 'https://www.varsitytutors.com/accessibility' },
] as const;

/** The lead form's footer (Footer.tsx), under the message box: the disclaimer, the links and the copyright. */
export function ChatFooter({ copyrightYear }: { copyrightYear: number }) {
  const [open, setOpen] = useState(false);
  const legalId = useId();
  return (
    <footer className="tpc-foot">
      <div className="tpc-foot-in">
        <ul className="tpc-foot-links">
          <li>
            <button type="button" aria-expanded={open} aria-controls={legalId} onClick={() => setOpen((current) => !current)}>
              {open ? 'Hide' : 'Show'} Disclaimer
            </button>
          </li>
          {LINKS.map((link) => (
            <li key={link.href}>
              <a href={link.href} target="_blank" rel="noopener noreferrer">
                {link.label}
              </a>
            </li>
          ))}
        </ul>
        <p className="tpc-foot-copy">Varsity Tutors ©2007-{copyrightYear}. All rights reserved.</p>
        <div className={open ? 'tpc-foot-legal is-open' : 'tpc-foot-legal'} id={legalId} aria-hidden={!open}>
          <p>Names of standardized tests are owned by the trademark holders and are not affiliated with Varsity Tutors LLC.</p>
          <p>Media outlet trademarks are owned by the respective media outlets and are not affiliated with Varsity Tutors.</p>
          <p>Award-Winning claim based on CBS Local and Houston Press awards.</p>
          <p>Varsity Tutors does not have affiliation with universities mentioned on its website.</p>
          <p>Varsity Tutors connects learners with a variety of experts and professionals.</p>
          <p>
            Tutors, instructors, experts, educators, and other professionals on the platform are independent contractors, who use their own styles, methods, and materials and
            create their own lesson plans based upon their experience, professional judgment, and the learners with whom they engage.
          </p>
          <p>
            ¹ Lee, J.Y. (2013). &quot;Private tutoring and its impact on students&apos; academic achievement, formal schooling, and educational inequality in Korea.&quot;
            Unpublished doctoral thesis. Columbia University.
          </p>
          <p>
            <a href="https://www.varsitytutors.com/cookie-list" target="_blank" rel="noopener noreferrer">
              Click for more information on your privacy rights.
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
